import request from "../utils/request";

// 热门游戏/game/hot/list
export const getHotList = () => {
  return request({
    url: "/game/public/list/hot",
    method: "get",
  });
};

// 游戏列表
export const pageList = (params, data) => {
  return request({
    url: `/game/public/page/${data.page}/${data.size}`,
    method: "post",
    params,
    data,
  });
};

// 游戏详情
export const getDetail = (id) => {
  return request({
    url: `/game/public/${id}`,
    method: "get",
  });
};
